import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import ImageStatic from '../ImageStatic'

import styles from './styles'


const decorators = [
  memoized,
]

function BurgerButton(props) {
  const { label, onTouchEnd } = props

  return (
    <a
      role="button"
      tabIndex={0}
      href="javascript:void(0);"
      className="container"
      onTouchEnd={onTouchEnd}
      onClick={onTouchEnd}
    >
      <ImageStatic
        className="icon"
        src="/images/icons/burger-menu.svg"
      />
      <span className="label">{label.toUpperCase()}</span>
      <style jsx>{styles}</style>
    </a>
  )
}

BurgerButton.propTypes = {
  label: PropTypes.string.isRequired,
  onTouchEnd: PropTypes.func.isRequired,
}

BurgerButton = chainDecorators(decorators, BurgerButton)

export default BurgerButton
